/**
 * Button variant styles for action buttons.
 */
export enum BarActionButtonType {
    /** Default button appearance (maps to 'outlined'). */
    Default = 'default',
    /** Filled button appearance. */
    Filled = 'filled',
    /** Outlined button appearance. */
    Outlined = 'outlined',
    /** Tonal button appearance. */
    Tonal = 'tonal',
    /** Text button appearance. */
    Text = 'text'
}
